import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/global.css";
import Disclaimer from "../components/Disclaimer";
import { Helmet } from "react-helmet-async";

const DisclaimerPage = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Read the disclaimer page of TimeWatch Infocom, your trusted provider of biometric solutions, access control systems, and smart security technologies. Our disclaimer outlines the terms and conditions governing the use of our website, including liability, accuracy of information, and intellectual property rights. Learn about the limitations of our services, including biometric time attendance systems, entrance automation, and parking management solutions. Ensure a clear understanding of the privacy, security, and legal guidelines when engaging with our cutting-edge security products and services."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/disclaimer"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="blogs">
          <Disclaimer />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default DisclaimerPage;
